import axios from 'axios';
import { auth } from '../url.js';
import { getToken } from '../tokenServices.js';

export const getLoginOptions = async (email) => {
    return await axios.post(auth.loginOptions, { email });
};

export const login = async (email, password, otp_method = null) => {
    const payload = { email, password };
    if (otp_method) {
        payload.otp_method = otp_method;
    }
    return await axios.post(auth.login, payload);
};

export const logout = async () => {
    return await axios.post(auth.logout);
};

export const register = async (email, name, password) => {
    return await axios.post(auth.register, { email, name, password });
};

export const forgotPassword = async (email) => {
    return await axios.post(auth.forgotPassword, { email });
};

export const resetPassword = async (email, reset_key, password) => {
    return await axios.post(auth.resetPassword, { email, reset_key, password });
};

export const verifyOtp = async (email, otp_code) => {
    return await axios.post(auth.verifyOtp, { email, otp_code });
};

export const updateProfile = async (data) => {
    const token = getToken();
    return await axios.post(auth.updateProfile, data, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
};
